import {injectable} from "inversify";
import {default as axios,Method} from "axios";
import { v4 as uuidv4 } from 'uuid';
import {removeUndefined} from "../helpers";

@injectable()
export default class FetchAjax {

    async fetch(
        {url, params, method = "post", timeout = 10000}:
            {url: string, params?: any, method?: Method, timeout?: number}
    ): Promise<any> {
        params = removeUndefined(params);
        let headers = {
            'X-Request-ID': getRequestId(),
            'Content-Type': getContentType(method)
        };
        return axios({
            method: method,
            url: url,
            data: params,
            headers: headers,
            timeout: timeout
        });
    }
}

function getRequestId() {
    return uuidv4();
}

function getContentType(method) {
    switch(method.toLowerCase()) {
        case "post":
        case "patch":
            return 'application/json';
        default:
        case "get":
            return 'application/x-www-form-urlencoded';
    }
}